<template>
  <div class="about-us-page">
    <!-- 头部导航 -->
    <!-- <div class="header">
      <i class="el-icon-arrow-left" @click="goBack"></i>
      <span>关于我们</span>
    </div> -->

    <!-- 页面内容 -->
    <div class="content-wrapper">
      <!-- 顶部图片 -->
      <div class="top-banner">
        <img src="./img/1.jpg" alt="大救星全球综合救援智能云平台" />
      </div>

      <!-- 江泰救援服务有限公司简介 -->
      <section class="section about-section">
        <div class="section-title">
          <h2>江泰救援服务有限公司简介</h2>
        </div>
        <div class="section-content">
          <p class="intro-text">
            2016年3月，江泰救援服务有限公司（以下简称江泰救援）在原国家旅游局的指导和推动下成立，总部设在北京（注册资金5000万元）。江泰救援是国内唯一一家自建全球合作服务网络的中资救援公司，并在原国家旅游局的授权下成立“中国公民全球救援指挥中心”。2019年8月，外交部致电驻外使领馆，将江泰救援纳入“海外救援医疗资源清单”，供我驻外使领馆在领事保护工作中联系使用。
          </p>
          <div class="honor-list">
            <div class="honor-item">
              <div class="honor-badge">自建全球合作服务网络的中资救援公司</div>
            </div>
            <div class="honor-item">
              <div class="honor-badge">原国家旅游局授权成立“中国公民全球救援指挥中心”</div>
            </div>
            <div class="honor-item">
              <div class="honor-badge">2019年外交部纳入“海外救援医疗资源清单”</div>
            </div>
          </div>
        </div>
      </section>

      <!-- 江泰救援组织架构 -->
      <section class="section">
        <div class="section-title">
          <h2>江泰救援组织架构</h2>
        </div>
        <div class="section-content">
          <p class="intro-text">
            公司秉承“有求必救”的理念，围绕着出行及生产生活等场景，提供“救援、救治、救助、救护”全方位的全球综合救援服务。先进独有的“大救星”全球综合救援智能云平台，将救援服务、安全保障与高科技融为一体，为客户提供全天候一键式服务。经过近十年的稳定运转及服务实践，得到了合作伙伴与客户的高度赞誉。
          </p>
          <p class="intro-text">
            “大救星”全球综合救援智能云平台是江泰救援研发并运营的全球综合服务平台。在大救星平台上，有触手可及的双语星使在线，有近在咫尺的专业机构待命，有保险保障支持的救援服务，有从救援、救治、救护及救助的全需求满足，拥有覆盖出行、生产生活等场景的全球救援、健康监测、全球医疗、安全防护等综合保障能力。
          </p>
          <div class="org-structure-img" @click="previewOrgStructure">
            <img :src="orgStructureImg" alt="江泰救援组织架构" />
            <div class="img-preview-tip">点击查看大图</div>
          </div>
        </div>
      </section>

      <!-- 一、大救星全球综合救援智能云平台 -->
      <section class="section">
        <div class="section-title">
          <h2>一、大救星全球综合救援智能云平台</h2>
        </div>
        <div class="section-content">
          <p class="intro-text">
            大救星平台基于移动互联网技术，通过整合境内外优质资源，以线上线下相结合的方式，用共享经济模式为出境的中国公民、入境的外国友人、境内国民提供及时、高效的全球综合服务。
          </p>
          <p class="intro-text">
            作为创新的智能化救援服务平台，大救星拥有针对B端用户的PC系统、针对C端用户的APP和小程序、操作便捷的机构版APP等工具。依靠多端协同，实现了关键节点流转及数据实时回传。此外，平台还实现了各角色间的职能互动，使操作可视化、数据透明化，打造更加高效、便捷的救援服务体验。
          </p>
        </div>
      </section>

      <!-- 二、全球服务网络 -->
      <section class="section network-section">
        <div class="section-title">
          <h2>二、全球服务网络</h2>
        </div>
        <div class="section-content">
          <div class="stats-panel">
            <div class="stats-grid">
              <div class="stat-card">
                <div class="stat-number">1200+</div>
                <div class="stat-label">境外服务商</div>
              </div>
              <div class="stat-card">
                <div class="stat-number">60万+</div>
                <div class="stat-label">服务网点</div>
              </div>
              <div class="stat-card">
                <div class="stat-number">3284</div>
                <div class="stat-label">境内外双语星使</div>
              </div>
              <div class="stat-card">
                <div class="stat-number">9家</div>
                <div class="stat-label">海外代表处</div>
              </div>
              <div class="stat-card">
                <div class="stat-number">137</div>
                <div class="stat-label">覆盖国家和地区</div>
              </div>
              <div class="stat-card">
                <div class="stat-number">820</div>
                <div class="stat-label">覆盖城市</div>
              </div>
            </div>
          </div>
          <p class="intro-text stats-follow-text">
            江泰救援目前在北京、海南、贵州、江苏、甘肃、云南设有分支机构，在北京、香港设有子公司，在亚洲、非洲、美洲、欧洲、大洋洲设有9家海外代表处。在境外拥有2340名常驻当地懂当地语言又熟悉中文的华人代表（即大救星星使），覆盖全球137个国家和地区、820个城市；境内拥有944名熟悉外语的大救星星使。
          </p>
          <p class="intro-text">
            江泰救援一直致力于全球网络资源的发展，资源考察足迹遍布全球200多个国家和地区。在我国驻各地使领馆和领保中心支持下，筛选签约符合平台质量要求的境外救援机构、律师事务所、会计师事务所、安保公司、旅行社、殡仪机构、包机公司、翻译公司等境外服务商1200多家，服务网点超60万个，将医疗救援、商旅助手、健康管理、健康监测、社区服务覆盖到全球。
          </p>
          <p class="intro-text">
            健康管理服务网络主要包含医疗机构网络、医生网络、护士网络、康复机构网络、购药送药网络等。服务场景从日常诊疗到诊前、诊中、院中、院后全覆盖，包含医疗费用担保/垫付、基础绿通、儿童绿通、重疾绿通、院后照护、健康体检、报告解读、眼科/齿科、慢病管理、医疗咨询、诊后营养康复指导等服务。绿通服务覆盖全国1000余家三甲医院，合作国内重点心、脑、癌专科名院，10000余家直付/垫付医院，可覆盖全国310多个城市。
          </p>
          <p class="intro-text">
            社区服务涵盖日常生活所需的各类服务，包含保洁、管道疏通、开锁、家电清洗及维修等服务，服务覆盖全国31个省（自治区、直辖市）的332个城市、2616个区县。
          </p>
        </div>
      </section>

      <!-- 三、主要服务内容 -->
      <section class="section services-section">
        <div class="section-title">
          <h2>三、主要服务内容</h2>
        </div>
        <div class="section-content">
          <div class="services-list">
            <div class="service-item">
              <div class="service-content">
                <div class="service-title">（一）大救星APP服务</div>
                <div class="service-desc">
                  快速查询境内外外交机构、领事保护机构、警察局、医院、药店位置，快速发起一键救援及一键报案功能。
                </div>
              </div>
            </div>
            <div class="service-item">
              <div class="service-content">
                <div class="service-title">（二）全球救援服务</div>
                <div class="service-desc">
                  大救星持续服务30多家知名保险公司、商业银行等金融机构，为2.3万家旅行社及近20家大型央、国企提供“四救十六助”全球综合救援服务，每年服务覆盖人群5000多万，双语星使累计提供服务1000余小时。
                </div>
              </div>
            </div>
            <div class="service-item">
              <div class="service-content">
                <div class="service-title">（三）救援服务清单</div>
                <div class="service-desc">
                  大救星首创“救援+保险”的救援服务清单产品。以救援服务清单为载体协助景区、滑雪场、旅行社等流量密集型场景构建“防、保、救、调、赔”五位一体的旅游安全应急救援保障体系。借助市场化手段帮助客户解决落实保障体系建设的资金及技术方案等。目前大救星已为国内300多家景区、滑雪场、旅行社提供服务。
                </div>
              </div>
            </div>
            <div class="service-item">
              <div class="service-content">
                <div class="service-title">（四）健康监测服务</div>
                <div class="service-desc">
                  大救星致力于通过救援服务前置降低因突发疾病造成的个人健康危害或意外事故发生几率。通过自主研发设计“大救星健康版”APP及健康监测设备，为客户提供365天*24小时的心率、心电、血氧、血压、体温等指标实时健康监测服务，通过主动提醒、健康风险预警、一键报案、语音互动等提供高效、便捷的健康预警服务，同时将健康监测、健康预警以及发生事故后的救援救助有效衔接，提供全流程的应急救援服务。大救星已为重型货车司机、金融高端客户等群体提供健康监测服务。
                </div>
              </div>
            </div>
            <div class="service-item">
              <div class="service-content">
                <div class="service-title">（五）全球医疗服务</div>
                <div class="service-desc">
                  大救星通过整合全球先进、优质的医疗资源，形成完善的全球医疗服务网络，为客户提供全球找药、特药安排等服务；通过“旅游+医疗”模式设计出高性价比且配套安全保障服务的全球医疗产品，为客户提供全球先进医疗就诊预约、手术预约、行程安排等全流程服务。已为客户提供包括赴韩医美、赴日体检、泰国辅助生育、美国肿瘤治疗、特药/靶向药等多项产品和服务。
                </div>
              </div>
            </div>
            <div class="service-item">
              <div class="service-content">
                <div class="service-title">（六）商旅助手</div>
                <div class="service-desc">
                  律师推介、安保服务、紧急撤离服务、危机公关处理、保释协调、应急现金协助、行程安排、酒店机票安排等。
                </div>
              </div>
            </div>
            <div class="service-item">
              <div class="service-content">
                <div class="service-title">（七）社区服务</div>
                <div class="service-desc">
                  大救星平台提供保洁、管道疏通、开锁、家电清洗、家电维修、甲醛检测、甲醛治理等服务，已成为目前国内最大的社区服务供应平台。
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 四、我们的服务优势 -->
      <section class="section advantages-section">
        <div class="section-title">
          <h2>四、我们的服务优势</h2>
        </div>
        <div class="section-content">
          <p class="intro-text">
            区别于传统救援公司，在大救星平台中，通过星使、专业合作机构、专属救援保险产品的有机结合，可实现六大优势：
          </p>
          <div class="advantages-list">
            <div class="advantage-item">
              <div class="advantage-icon">📱</div>
              <div class="advantage-content">
                <div class="advantage-title">（一）移动互联网平台式救援</div>
                <div class="advantage-desc">通过大救星APP或微信小程序实现一键救援，实时定位，精准服务。</div>
              </div>
            </div>
            <div class="advantage-item">
              <div class="advantage-icon">⚡</div>
              <div class="advantage-content">
                <div class="advantage-title">（二）快速响应、服务满意度100%</div>
                <div class="advantage-desc">全年365天7x24小时中英双语服务，10秒内接听电话、15分钟内协调服务、全流程实时反馈服务进度。专业、高效、贴心处理客户的每一次服务需求，满意度近100%。</div>
              </div>
            </div>
            <div class="advantage-item">
              <div class="advantage-icon">🌟</div>
              <div class="advantage-content">
                <div class="advantage-title">（三）全球独有的星使现场服务</div>
                <div class="advantage-desc">依托大救星平台，用户可随时随地发起服务需求，星使提供现场陪同、陪护、翻译、代办等现场服务。</div>
              </div>
            </div>
            <div class="advantage-item">
              <div class="advantage-icon">🌐</div>
              <div class="advantage-content">
                <div class="advantage-title">（四）综合服务资源及能力</div>
                <div class="advantage-desc">从单一医疗救援服务商，扩展到包括境内外健康管理机构、医疗团队、当地律所、旅行社、安保公司、翻译公司等综合性服务商，实现救援、救治、救护、救助的一站式全方位综合服务。</div>
              </div>
            </div>
            <div class="advantage-item">
              <div class="advantage-icon">🏥</div>
              <div class="advantage-content">
                <div class="advantage-title">（五）健康管理服务全场景渗透</div>
                <div class="advantage-desc">可为客户提供日常诊疗咨询、诊前、诊中、院中、院后全流程及一站式服务，并支持保险产品定制开发。</div>
              </div>
            </div>
            <div class="advantage-item">
              <div class="advantage-icon">📋</div>
              <div class="advantage-content">
                <div class="advantage-title">（六）创新清单产品</div>
                <div class="advantage-desc">创新推出适宜旅游、商务、探亲、劳务和留学的清单产品：在符合救援条件的前提下，提供救援服务无用户年龄限制、无既往病史限制、无风险运动限制、无地理区域限制、无救援次数限制、无救援额度限制的全面保障。</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 五、定位及发展方向 -->
      <section class="section">
        <div class="section-title">
          <h2>五、定位及发展方向</h2>
        </div>
        <div class="section-content">
          <div class="services-list">
            <div class="service-item">
              <div class="service-content">
                <div class="service-title">（一）从传统救援向综合救援转型</div>
                <div class="service-desc">
                  在传统医疗救援的基础上，大救星平台提供“四救十六助”综合服务，依托覆盖全球的服务商网络及星使网络，真正实现“一键救援”、“有求必救”的便捷、综合服务。
                </div>
              </div>
            </div>
            <div class="service-item">
              <div class="service-content">
                <div class="service-title">（二）从出行场景向生活场景转型</div>
                <div class="service-desc">
                  在不断完善升级围绕出行场景的“四救十六助”服务的基础上，大救星平台不断丰富应用场景：围绕社区家庭生活场景推出家庭维保服务，围绕“一老一小一宠物”推出家庭照护服务等，围绕大健康领域推出覆盖国内县级以上城市的健康管理“绿通”服务，围绕特定职业人群、带病体人群提供保险保障、健康监测、健康趋势预报、突发疾病及时预警、私人医生、买药送药、紧急救援、健康管理等全流程、全周期服务。
                </div>
              </div>
            </div>
            <div class="service-item">
              <div class="service-content">
                <div class="service-title">（三）提供全生命周期的健康管理服务</div>
                <div class="service-desc">
                  依托“人工智能+大救星健康版App”通过保险保障+智能设备+健康监测预警系统+全球救援网络的大救星智能云平台，为用户提供保险转嫁、健康监测、疾病预警、医疗咨询、医疗救援、医疗费用直付/垫付、院后康复、找药送药、慢病管理等综合服务，实现对用户全生命周期的健康管理。
                </div>
              </div>
            </div>
            <div class="service-item">
              <div class="service-content">
                <div class="service-title">（四）大救星公益</div>
                <div class="service-desc">
                  大救星始终坚持不忘善良初心，致力于将爱心传递、薪火相传，积极推动大救星公益板块落地发展。目前已与海南省医疗救助基金会达成合作，共同推动为国内就诊人员提供公益服务及救助服务。
                </div>
              </div>
            </div>
          </div>
          <p class="intro-text closing-text">
            大救星平台是政府救援的重要补充，是商业救援的创新模式，围绕着出行和生活场景构建了中国公民/海外公民、境内外救援救助机构、健康管理机构以及个体服务者“星使”及医疗人员之间的服务生态圈。目前，江泰救援独有的星使网络已为个人客户现场服务近5000个小时；连续十年为国内2.3万余家旅行社提供全球服务保障，服务累计覆盖超过2亿人次；并与国家签证平台合作，为通过全球95家境外中国签证申请服务中心来华的外籍游客提供救援服务保障。客户还包括中国化学工程集团、中交建工程集团等大型境外劳务企业，中国工商银行、中国农业银行等大型商业银行，中国平安财产股份保险公司、中国平安人寿股份保险公司、中国平安健康股份保险公司、中国太平洋财产股份有限公司、中国人寿财险保险公司、阳光财产保险公司等30多家保险公司，贵州黄果树瀑布、贵州万峰林、贵州千户苗寨、河北东太行、甘肃万象洞、甘肃马蹄寺、山西云丘山等大型旅游景区集团。
          </p>
        </div>
      </section>

      <!-- 联系我们 -->
      <section class="section contact-section">
        <div class="section-title">
          <h2>联系我们</h2>
        </div>
        <div class="section-content">
          <div class="contact-list">
            <!-- 官网 -->
            <div class="contact-card website-card">
              <div class="contact-icon-wrapper">
                <i class="el-icon-link contact-icon"></i>
              </div>
              <div class="contact-info">
                <div class="contact-title">大救星官网</div>
                <a href="https://www.dajiuxing.com.cn" target="_blank" class="contact-link">
                  www.dajiuxing.com.cn
                  <i class="el-icon-right link-arrow"></i>
                </a>
              </div>
            </div>

            <!-- 24小时救援热线 -->
            <div class="contact-card emergency-card">
              <div class="contact-icon-wrapper emergency-icon-wrapper">
                <i class="el-icon-phone contact-icon"></i>
              </div>
              <div class="contact-info">
                <div class="contact-title-wrapper">
                  <div class="contact-title">24小时救援服务热线</div>
                  <div class="contact-tag">全天候服务</div>
                </div>
                <a href="tel:+86-10-83423665" class="contact-phone emergency-phone">
                  +86-10-83423665
                  <i class="el-icon-phone-outline phone-icon"></i>
                </a>
              </div>
            </div>

            <!-- 清单购买/合作咨询 -->
            <div class="contact-card business-card">
              <div class="contact-icon-wrapper business-icon-wrapper">
                <i class="el-icon-message contact-icon"></i>
              </div>
              <div class="contact-info">
                <div class="contact-title">清单购买/合作咨询</div>
                <div class="phone-group">
                  <a href="tel:15542608636" class="contact-phone">
                    <i class="el-icon-phone-outline"></i>
                    15542608636
                  </a>
                  <a href="tel:13651178992" class="contact-phone">
                    <i class="el-icon-phone-outline"></i>
                    13651178992
                  </a>
                </div>
                <div class="contact-time">
                  <i class="el-icon-time"></i>
                  周一至周日 9:00-17:00
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>

    <!-- App 版本号（原生 getAppVersionName → getAppVersionNameResult） -->
    <footer v-if="appVersionName" class="app-version-footer">
      <span class="app-version-label">当前版本:</span>
      <span class="app-version-value">v{{ appVersionName }}</span>
    </footer>
  </div>
</template>

<script>
import { ImagePreview } from 'vant';
import orgStructureImg from './img/org-structure.png';

export default {
  name: 'AboutUs',
  data() {
    return {
      orgStructureImg,
      /** App 版本号，由原生 getAppVersionNameResult 回传 */
      appVersionName: ''
    };
  },
  mounted() {
    document.title = '关于我们 - 大救星';
    this.bindAppVersionCallback();
    this.requestAppVersionName();
  },
  beforeDestroy() {
    this.unbindAppVersionCallback();
  },
  methods: {
    /**
     * 返回上一页
     */
    goBack() {
      this.$router.go(-1);
    },
    /**
     * 预览组织架构大图
     */
    previewOrgStructure() {
      ImagePreview({
        images: [this.orgStructureImg],
        closeable: true
      });
    },
    /**
     * 挂载原生回调：App 调用 getAppVersionNameResult('3.0.03')
     * @returns {void}
     */
    bindAppVersionCallback() {
      this._prevAppVersionCb =
        typeof window !== 'undefined' ? window.getAppVersionNameResult : null;
      /**
       * @param {string} version
       * @returns {void}
       */
      window.getAppVersionNameResult = (version) => {
        const v = version != null ? String(version).trim() : '';
        if (v) this.appVersionName = v;
      };
    },
    /**
     * 卸载原生回调，避免泄漏
     * @returns {void}
     */
    unbindAppVersionCallback() {
      if (typeof window === 'undefined') return;
      window.getAppVersionNameResult = this._prevAppVersionCb || null;
    },
    /**
     * 调用原生 getAppVersionName 获取版本号
     * @returns {void}
     */
    requestAppVersionName() {
      try {
        if (this.$env && this.$env.inAndroid) {
          const api =
            (window.JSInterface && window.JSInterface.getAppVersionName) ||
            (typeof JSInterface !== 'undefined' && JSInterface.getAppVersionName);
          if (typeof api === 'function') {
            const ret =
              window.JSInterface && typeof window.JSInterface.getAppVersionName === 'function'
                ? window.JSInterface.getAppVersionName()
                : JSInterface.getAppVersionName();
            // 部分机型同步返回；标准约定仍以 getAppVersionNameResult 回调为准
            if (ret != null && String(ret).trim()) {
              this.appVersionName = String(ret).trim();
            }
            return;
          }
        }
        if (
          this.$env &&
          this.$env.inIos &&
          window.webkit &&
          window.webkit.messageHandlers &&
          window.webkit.messageHandlers.getAppVersionName
        ) {
          window.webkit.messageHandlers.getAppVersionName.postMessage(null);
        }
      } catch (e) {
        console.warn('获取 App 版本号失败', e);
      }
    }
  }
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.about-us-page {
  min-height: 100vh;
  background: linear-gradient(180deg, #f5f7fa 0%, #ffffff 100%);
  padding-bottom: 20px;
}

/* App 版本号底部展示 */
.app-version-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 8px 16px 28px;
  color: #999;
  font-size: 13px;
  line-height: 1.4;
}

.app-version-label {
  color: #b0b8c0;
}

.app-version-value {
  color: #8a9399;
  font-weight: 500;
  letter-spacing: 0.02em;
}

/* 头部导航 */
.header {
  position: sticky;
  top: 0;
  z-index: 100;
  background: #fff;
  height: 44px;
  line-height: 44px;
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  color: #333;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.header i {
  position: absolute;
  left: 15px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 20px;
  color: #333;
  cursor: pointer;
}

/* 内容区域 */
.content-wrapper {
  padding: 15px;
  max-width: 100%;
}

/* 顶部图片横幅 */
.top-banner {
  width: 100%;
  margin-bottom: 15px;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}

.top-banner img {
  width: 100%;
  height: auto;
  display: block;
  object-fit: cover;
}

/* 通用区块样式 */
.section {
  background: #fff;
  border-radius: 12px;
  margin-bottom: 15px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
}

.section-title {
  background: linear-gradient(135deg, #00D0B8 0%, #05a520 100%);
  padding: 15px 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.title-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
}

.section-title h2 {
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  margin: 0;
  text-align: center;
  line-height: 1.4;
}

.section-content {
  padding: 20px;
}

/* 全球服务网络数据面板背景图 */
.stats-panel {
  background-image: url('./img/2.jpg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 12px;
  padding: 15px;
  margin-bottom: 5px;
}

/* 关于我们部分 */
.intro-text {
  font-size: 14px;
  line-height: 1.8;
  color: #666;
  margin-bottom: 15px;
  text-align: justify;
}

.intro-text:last-of-type {
  margin-bottom: 0;
}

.stats-follow-text {
  margin-top: 20px;
}

.closing-text {
  margin-top: 20px;
}

.honor-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 15px;
}

.honor-item {
  padding: 12px 11px;
  background: linear-gradient(135deg, #f5f7fa 0%, #e8ecf1 100%);
  border-radius: 8px;
  border-top: 4px solid #00D0B8;
}

.honor-badge {
  font-size: 13px;
  color: #333;
  line-height: 1.6;
}

/* 组织架构图 */
.org-structure-img {
  position: relative;
  margin-top: 20px;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
}

.org-structure-img img {
  width: 100%;
  height: auto;
  display: block;
}

.img-preview-tip {
  position: absolute;
  right: 8px;
  bottom: 8px;
  padding: 4px 10px;
  background: rgba(0, 0, 0, 0.55);
  color: #fff;
  font-size: 12px;
  border-radius: 12px;
  line-height: 1.4;
  pointer-events: none;
}

/* 全球服务网络 - 数据卡片 */
.stats-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 15px;
  margin-bottom: 5px;
}

.stat-card-full {
  grid-column: 1 / -1;
}

.stat-card {
  background: rgba(0, 0, 0, 0.4);
  border-radius: 12px;
  padding: 20px 15px;
  text-align: center;
  color: #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

.stat-number {
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 8px;
  line-height: 1.2;
}

.stat-label {
  font-size: 13px;
  opacity: 0.95;
  line-height: 1.4;
}

/* 服务优势 */
.advantages-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.advantage-item {
  display: flex;
  align-items: flex-start;
  gap: 15px;
  padding: 15px;
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  border-radius: 10px;
  border: 1px solid #e9ecef;
  transition: all 0.3s ease;
}

.advantage-item:hover {
  box-shadow: 0 4px 12px rgba(0, 208, 184, 0.15);
  transform: translateY(-2px);
}

.advantage-icon {
  font-size: 32px;
  flex-shrink: 0;
}

.advantage-content {
  flex: 1;
}

.advantage-title {
  font-size: 15px;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
}

.advantage-desc {
  font-size: 13px;
  color: #666;
  line-height: 1.7;
  text-align: justify;
}

/* 主要服务内容 */
.services-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.service-item {
  display: flex;
  gap: 15px;
  padding: 18px;
  background: #f8f9fa;
  border-radius: 10px;
  border-left: 4px solid #00D0B8;
}

.service-number {
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  background: linear-gradient(135deg, #00D0B8 0%, #05a520 100%);
  color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 600;
}

.service-content {
  flex: 1;
}

.service-title {
  font-size: 15px;
  font-weight: 600;
  color: #333;
  margin-bottom: 10px;
}

.service-desc {
  font-size: 13px;
  color: #666;
  line-height: 1.8;
  text-align: justify;
}

/* 联系我们 */
.contact-list {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.contact-card {
  display: flex;
  align-items: flex-start;
  gap: 15px;
  padding: 20px;
  background: #fff;
  border-radius: 12px;
  border: 1px solid #e9ecef;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  transition: all 0.3s ease;
}

.contact-card:hover {
  box-shadow: 0 4px 16px rgba(0, 208, 184, 0.15);
  transform: translateY(-2px);
}

.contact-icon-wrapper {
  flex-shrink: 0;
  width: 50px;
  height: 50px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #00D0B8 0%, #05a520 100%);
}

.emergency-icon-wrapper {
  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a6f 100%);
  animation: pulse 2s infinite;
}

.business-icon-wrapper {
  background: linear-gradient(135deg, #4ecdc4 0%, #00D0B8 100%);
}

.contact-icon {
  font-size: 24px;
  color: #fff;
}

.contact-info {
  flex: 1;
  min-width: 0;
}

.contact-title-wrapper {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
  flex-wrap: wrap;
}

.contact-title {
  font-size: 15px;
  font-weight: 600;
  color: #333;
  margin-bottom: 0;
}

.contact-link {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 15px;
  color: #00D0B8;
  text-decoration: none;
  font-weight: 500;
  transition: all 0.3s ease;
  word-break: break-all;
}

.contact-link:hover {
  color: #05a520;
  text-decoration: underline;
}

.link-arrow {
  font-size: 14px;
  transition: transform 0.3s ease;
}

.contact-link:hover .link-arrow {
  transform: translateX(3px);
}

.contact-phone {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 16px;
  color: #333;
  text-decoration: none;
  font-weight: 500;
  padding: 8px 12px;
  background: #f8f9fa;
  border-radius: 8px;
  margin-bottom: 8px;
  transition: all 0.3s ease;
}

.contact-phone:hover {
  background: #e9ecef;
  color: #00D0B8;
}

.contact-phone i {
  font-size: 14px;
  color: #00D0B8;
}

.emergency-phone {
  font-size: 18px;
  font-weight: 600;
  color: #ff6b6b;
  background: #fff5f5;
  padding: 12px 16px;
  border-radius: 10px;
  margin-bottom: 10px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.emergency-phone:hover {
  background: #ffe0e0;
  color: #ee5a6f;
}

.emergency-phone .phone-icon {
  color: #ff6b6b;
  font-size: 18px;
}

.phone-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 10px;
}

.contact-tag {
  display: inline-block;
  padding: 4px 10px;
  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a6f 100%);
  color: #fff;
  font-size: 12px;
  border-radius: 12px;
  font-weight: 500;
  margin: 0;
  flex-shrink: 0;
}

.contact-time {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: #999;
  margin-top: 8px;
}

.contact-time i {
  font-size: 14px;
  color: #00D0B8;
}

/* 紧急热线脉冲动画 */
@keyframes pulse {
  0%, 100% {
    box-shadow: 0 0 0 0 rgba(255, 107, 107, 0.4);
  }
  50% {
    box-shadow: 0 0 0 8px rgba(255, 107, 107, 0);
  }
}

/* 响应式设计 */
@media (max-width: 375px) {
  .stats-grid {
    grid-template-columns: 1fr;
  }

  .stat-number {
    font-size: 22px;
  }

  .section-title h2 {
    font-size: 15px;
  }
}

@media (min-width: 768px) {
  .content-wrapper {
    max-width: 750px;
    margin: 0 auto;
  }

  .stats-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/aboutUs/index.vue